import React from "react";
import { Link } from 'react-router-dom';
import './supplier.css'

const UserNav = ({ id }) => {

    return (
        <div className="py-lg-5">
            <div className="topnav maon-BG">
                <div className="container">
                    <div className="nav nav-pills overslid d-flex justify-content-between">
                        <Link to="/admin/master/userMaster/list" className={`dashitems sidebar-text center  ${id === "list" ? "active" : ""}`}>
                            Users</Link>
                        <Link to="/admin/master/userMaster/create" className={`dashitems sidebar-text center ${id === "create" ? "active" : ""}`}>
                            Add User</Link>
                        {/* <Link to="/Inventory/UserMaster/access" className={`dashitems sidebar-text center ${id === "access" ? "active" : ""}`}>
                            Access & Rights</Link> */}
                        <Link to="/admin/master/userMaster/rights" className={`dashitems sidebar-text center ${id === "rights" ? "active" : ""}`}>
                           User Rights</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default UserNav; 